import { render, staticRenderFns } from "./feetable_init.vue?vue&type=template&id=8108e0a4&scoped=true&"
import script from "./feetable_init.vue?vue&type=script&lang=js&"
export * from "./feetable_init.vue?vue&type=script&lang=js&"
import style0 from "./feetable_init.vue?vue&type=style&index=0&id=8108e0a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8108e0a4",
  null
  
)

export default component.exports